import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-5-5v-2l7.5-7.5a1.414 1.414 0 0 1 2 2L9 17z",
      clipRule: "evenodd"
    }
  )
);
var SvgDraftCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DraftCircleFilled_default = SvgDraftCircleFilled;

export { DraftCircleFilled_default as default };
